import { useEffect } from 'react'

import { SegmentAction, segmentTracking } from 'src/helpers/segment'

// Keys are the GUEST_COUNT bucket values stored by GuestCount.tsx.
export const GUEST_BUDGET_ANCHORS: Record<string, { range: string; subtitle: string }> = {
  '0': {
    range: '$2000 - $3000',
    subtitle: 'Couples with < 50 guests typically invest $2000 - $3000 with Poppy',
  },
  '50': {
    range: '$2,000–$4,000',
    subtitle: 'Couples with 50 - 100 guests typically invest $2,000–$4,000 with Poppy',
  },
  '100': {
    range: '$2,500–$4,000',
    subtitle: 'Couples with 100 - 150 guests typically invest $2,500–$4,000 with Poppy',
  },
  '200': {
    range: '$2,500–$5,500',
    subtitle: 'Couples with 150+ guests typically invest $2,500–$5,500 with Poppy',
  },
}

export const useBudgetAnchorSubtitle = (guestCountBucket?: string): string | undefined => {
  const anchor = guestCountBucket ? GUEST_BUDGET_ANCHORS[guestCountBucket] : undefined

  useEffect(() => {
    // Exposure event: no subtitle renders for absent/unrecognized buckets, so the exposed
    // population cannot be reconstructed from existing data without this.
    segmentTracking(SegmentAction.SQ_BUDGET_ANCHOR_SHOWN, {
      guestCountBucket,
      range: anchor?.range,
      shown: !!anchor,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestCountBucket])

  return anchor?.subtitle
}
